import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { BPBillRequestFormHelper,BPBillRequestFormState} from './bp-billRequest-form.helper';
import { BaseFpxFormComponent,CriteriaQuery,ValidatorService } from '@fpx/core';
import { BillRequestService } from '../billRequest-service/billRequest.service';
import { BillRequest } from '../billRequest-service/billRequest.model';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
 selector: 'app-bp-billRequest-form',
  templateUrl: './bp-billRequest-form.component.html',
  styleUrls: ['./bp-billRequest-form.component.scss'],
})

export class BPBillRequestFormComponent extends BaseFpxFormComponent<BPBillRequestFormHelper, BPBillRequestFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public bPBillRequestFormHelper: BPBillRequestFormHelper,
    public billRequestService: BillRequestService,
    private validatorService: ValidatorService,
    private _matDialogRef: MatDialogRef<BPBillRequestFormComponent>

  ) {
    super(formBuilder, router,controlContainer, bPBillRequestFormHelper);
  }

 protected override doPreInit(): void {
   this.addFormControl('fromDate', '', [Validators.required]);
   this.addFormControl('toDate', '', [Validators.required]);
	 this.setDataService(this.billRequestService);
 }
 submitForm() {
  let fromDate = this.formGroup.get('fromDate').value;
  let toDate = this.formGroup.get('toDate').value;
  const criteria:CriteriaQuery = new CriteriaQuery();
  // criteria.addSortCriteria('paymentDate','asc','String');
  criteria.addFilterCritertia(
    'paymentDate',
    'Date',
    'inRange',
    {
      fromValue: fromDate,
      toValue: toDate,
    });
  // criteria.addQueryparam('toDate', "2022-09-30");
  this.billRequestService.isBillHistoryAvailable = true;
  this._matDialogRef.close(criteria);
 }


}
